import { render } from "./ModalMultaPagadaComponent.vue?vue&type=template&id=558693d1&scoped=true"
import script from "./ModalMultaPagadaComponent.vue?vue&type=script&lang=js"
export * from "./ModalMultaPagadaComponent.vue?vue&type=script&lang=js"

import "./ModalMultaPagadaComponent.vue?vue&type=style&index=0&id=558693d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558693d1"]])

export default __exports__